import { ModalType } from './screenerValidation';

export const buildUpdatePayload = (study: Study, modalType: ModalType) => {
  const updatePayload: {
    id: number;
    qualification_screener_review?: Study['qualification_screener_review'];
    disqualification_screener_review?: Study['disqualification_screener_review'];
  } = {
    id: study.id
  };

  if (modalType === 'both') {
    updatePayload.qualification_screener_review = 'manual';
    updatePayload.disqualification_screener_review = 'manual';
  } else if (modalType === 'qualification') {
    updatePayload.qualification_screener_review = 'manual';
  } else if (modalType === 'disqualification') {
    updatePayload.disqualification_screener_review = 'manual';
  }

  return updatePayload;
};
